<template>
    <li class="equipments-list-item">
        <span class="text">
            {{ product.name }}{{ product.variantTitle ? ' (' + product.variantTitle + ')' : '' }}
            <button v-if="hasDetails && itemStyle === 'flex' && !showDetails" class="show-detail-trigger" :class="brandColor" @click="showDetails = !showDetails">
                {{ (showDetails ? $t('less_details') : $t('details')) }}
            </button>
        </span>
        <transition name="fade">
            <div class="details" v-if="showDetails">
                <div class="details-text" v-if="description" v-html="description"></div>
                <div class="details-text" v-if="benefits" v-html="benefits"></div>
                <img :src="picture" alt="" v-if="picture" class="details-picture" />
            </div>
        </transition>
        <button v-if="hasDetails && (itemStyle !== 'flex' || showDetails)" class="show-detail-trigger" :class="brandColor" @click="showDetails = !showDetails">
          {{ (showDetails ? $t('less_details') : $t('details')) }}
        </button>
    </li>
</template>

<script>
    import mediaService from '@/services/akeneo/media'

    export default {
        name: 'EquipmentListItem',
        props: {
            product: {
                type: Object,
                default: {}
            },
            itemStyle: {
              type: String,
              required: false,
              default: 'block'
            }
        },
        data(){
            return {
                showDetails: false,
                picture: null
            }
        },
        computed: {
            hasDetails(){
                return (this.description || this.picture || this.benefits);
            },
            description(){
                var description = this.product.attributes.find(x=>x.code==='description')
                return (description && description.value.label.trim()!==this.product.name.trim()) ? description.value.label : false
            },
            benefits(){
              var benefits = this.product.attributes.find(x=>x.code==='benefits')
              return (benefits && benefits.value.label.trim()!==this.product.name.trim()) ? benefits.value.label : false
            }
        },
        created() {
            if(this.product.thumbnail && !this.product.thumbnail.indexOf('sans_photos'))
                this.fetchPicture();
        },
        methods: {
            fetchPicture() {
                this.picture=this.product.thumbnail
            }
        },
    }
</script>

<style lang="scss">
    .equipments-list-item {
        //margin-top: 20px;
        font-size: 15px;

        .text {
            display: block
        }

        .details {
            margin-top: 5px;

            .details-text {
              //  color: #b9b9b9;
                margin-bottom: 10px;
            }

            .details-picture {
                max-width: 230px;
            }
        }

        .show-detail-trigger {
            text-decoration: underline;
            cursor: pointer;
        }
    }
</style>